ScrollableView = require("../scrollable/view")
Preloader      = require("lib/preload")
{ dpi }        = require("lib/device")

class ScrollingMediaView extends ScrollableView
  template: require("./template")
  ignoreStateOnRefresh: true

  events: ->
    _.extend super,
      "iostap .multi-content-wrapper-image": "showZoom"

  setHeight: (narrationIsComplete, y) ->
    scroller = @findOne(".content-scroll")

    images = _.pluck @findAll("img"), "src"

    Preloader.load images, (e) =>
      super narrationIsComplete, y

  show: ->
    super
    @setState not @options.data.preventFocus, "image-focus"

  onRefresh: ->
    @photoswipe?.close()
    @show()

  hide: ->
    super
    @photoswipe?.close()

  showZoom: (e, showAnimationDuration = 300) ->
    return if @options.data.preventFocus

    @setState("touched")
    @setState(true, "focus")

    targetImage = e.currentTarget.querySelector("img")

    pad = if @options.data.compose then 12 else 0
    { top, left, width } = targetImage.getBoundingClientRect()
    thumbBounds = { x: left + pad, y: top + pad, w: width - pad * 2 }

    images =
      for img, i in @findAll(".multi-content-image")
        index = i if img is targetImage
        img: img
        msrc: img.src
        src:  img.src
        w: (img.naturalWidth  or img.width)  / Math.min(dpi, 1.66)
        h: (img.naturalHeight or img.height) / Math.min(dpi, 1.66)

    @photoswipe = new PhotoSwipe(
      document.querySelector("#photoswipe")
      PhotoSwipeUI_Default
      images
      {
        index
        showAnimationDuration
        focus: false
        history: false
        barsSize: { top: 0, bottom: 0 }
        indexIndicatorSep: " of "
        getThumbBoundsFn: -> thumbBounds
      }
    )
    @photoswipe.listen("close", => @setState(false, "focus"))
    @photoswipe.init()

module.exports = ScrollingMediaView
